import { BehaviorSubject } from 'rxjs';
import { Formation } from '../../model/formation.model';
import { Student } from '../../model/student.model';
import { FormationService } from '../../service/formation.service';
import { ExerciceCategoryService } from '../../service/exerciceCategory.service';
import { ExerciceSpecificContentService } from '../../service/exerciceSpecificContent.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Teacher } from '../../model/teacher.model';
import { AuthenticationService } from '../../service/authentification.service';
import { TaskService } from '../../service/task.service';
import { HttpParams } from '@angular/common/http';
import { ExerciceSheetService } from '../../service/exerciceSheet.service';
import { Component, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { ExerciceSheet } from '../../model/exerciceSheet.model';
import { Occurrence } from '../../model/occurrence.model';
import { Task } from '../../model/task.model';
import { ExerciceCategory } from '../../model/exerciceCategory.model';
import { ExerciceSpecificContent } from '../../model/exerciceSpecificContent.model';
import { debounceTime } from 'rxjs/operators';
import { Exercice } from '../../model/exercice.model';
import { ExerciceService } from '../../service/exercice.service';

@Component({
  selector: 'app-exercice-assign',
  templateUrl: './exercice-assign.component.html',
  styleUrls: ['./exercice-assign.component.scss']
})
export class ExerciceAssignComponent implements AfterViewInit {
  @Input() formation: Formation;
  @Input() selectedSheet: ExerciceSheet;
  @Input() reportAddedSheet // report to parent component if sheet was added
  @Input() validatedByStudent: Student;
  @Output() emitSheetToView = new EventEmitter();
  @Output() isSheetAdded = new EventEmitter();
  @Input() typeExercice: string;
  currentUser: Teacher;
  exerciceList: Exercice[] = [];
  taskSheetToDo: Task[] = [];
  categoryList: ExerciceCategory[] = [];
  cecrlLevelList;
  groupList: ExerciceSpecificContent[] = null;
  limitedGroupList: ExerciceSpecificContent[] = null;
  showFilterMenu = false;
  loadSheets = false;
  site;
  nextPage = 1;
  isDataSpecificContentReadyObservable;
  countTotalSheets = 0;

  filterSearchGroup = new FormGroup({
    title: new FormControl(),
  });

  filterFormGroup = new FormGroup({
    cecrl_level: new FormControl(),
    category: new FormControl(),
    specific_content: new FormControl(),
    limited_specific_content: new FormControl(),
    status: new FormControl(),
  });

  constructor(
    private exerciceSheetService: ExerciceSheetService,
    private authenticationService: AuthenticationService,
    private exerciceSpecificContentService: ExerciceSpecificContentService,
    private exerciceCategoryService: ExerciceCategoryService,
    private taskService: TaskService,
    private formationService: FormationService,
    private exerciceService: ExerciceService
  ) { }

  ngAfterViewInit() {
    this.site = localStorage.getItem('site');
    this.isDataSpecificContentReadyObservable = new BehaviorSubject(false);
    this.resetFilters();
    this.currentUser = this.authenticationService.currentUserSubject.value;
    this.cecrlLevelList = this.exerciceSheetService.getcecrlLevel();
    this.exerciceCategoryService.getCategories(null).subscribe(data => {
      if (data['results']) {
        this.categoryList = data['results'];
      }
    });
    const params = new HttpParams().set('status', 'active');
    this.exerciceSpecificContentService.getExercicesSpecificContent(params).subscribe(data => {
      if (data['results']) {
        this.groupList = data['results'];
        this.isDataSpecificContentReady();
      }
    })
    if (this.formation) {
      this.limitedGroupList = this.formation.specific_content;
      this.isDataSpecificContentReady();
    }
    if (this.formation) {
      this.limitedGroupList = this.formation.specific_content;
      this.isDataSpecificContentReady();
    }
    this.filterFormGroup.valueChanges.subscribe(data => {
      this.newSearch();
    });
    this.filterSearchGroup.valueChanges.pipe(debounceTime(1000)).subscribe(data => {
      this.newSearch();
    });
    if (this.formation) {
      this.getAssignedSheetList();
    }
    this.getAvailableExercice();
    this.isDataSpecificContentReadyObservable.subscribe(isReady => {
      if (isReady) {
        this.filterGroupList();
      }
    });

    if (!this.formation) {
      this.isDataSpecificContentReadyObservable.next(true);
    }
  }



  isDataSpecificContentReady() {
    if (this.limitedGroupList && this.limitedGroupList.length != null && this.groupList != null) {
      this.isDataSpecificContentReadyObservable.next(true);
    }
  }

  checkSpecificContent(sheet: ExerciceSheet) {
    if (sheet.specific_content.length === 0) {
      return true;
    }
    if (this.formation) {
      if (this.formation.specific_content.filter(sc => sheet.specific_content.map(sc => sc.id).indexOf(sc.id) > -1).length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  filterGroupList() {
    this.groupList = this.groupList.filter(g => this.limitedGroupList.map(sc => sc.id).indexOf(g.id) > -1)
    this.groupList = this.groupList.filter(g => g.code !== 'default')
  }

  getAssignedSheetList() {
    const params = new HttpParams()
      .set('salt', Math.random().toString())
      .set('recipient_model', 'student')
      .set('recipient_entity_id', this.formation.student.id.toString())
      .set('what_model', 'exercice')
      .set('for_model', 'formation')
      .set('for_entity_id', this.formation.id.toString())
      .set('is_validate_by_student', this.formation.student.id.toString())
      .set('is_todo_by_student', this.formation.student.id.toString())

    this.taskService.getTasks(params).subscribe(data => {
      if (data.results) {
        this.taskSheetToDo = data.results;
        this.excludeAssignedSheet();
      }
    })
  }

  getAvailableExercice() {
    let params = new HttpParams()
      .set('status', 'published') // filter on student entity
      .set('ordering', '-pk')
      .set('page_size', '20')
      .set('type_exercice', this.typeExercice)
      .set('page', this.nextPage.toString())
      .set('salt', Math.random().toString());

    if (this.typeExercice === 'offsite') {
      params = params.set('teacher', this.currentUser.id.toString())
    }

    if (this.selectedSheet) {
      params = params.set('sheets', this.selectedSheet.id.toString());
    }

    if (this.filterSearchGroup.controls.title.value) {
      params = params.set('title__icontains', this.filterSearchGroup.controls.title.value)
    }

    const that = this;
    this.exerciceService.getExercices(params).subscribe(data => {
      if (data) {
        that.exerciceList = that.exerciceList.concat(data.results);
        that.countTotalSheets = data.count;
        that.excludeAssignedSheet();
        if (data.next) {
          that.nextPage = that.exerciceSheetService.getUrlParams(data.next, 'page');
        } else {
          that.nextPage = null;
        }
      }
      this.loadSheets = false;
    })
  }

  resetFilters() {
    this.filterFormGroup.controls.cecrl_level.setValue('');
    this.filterFormGroup.controls.category.setValue('');
    this.filterFormGroup.controls.status.setValue('');
    this.filterFormGroup.controls.specific_content.setValue('');
    this.filterFormGroup.controls.limited_specific_content.setValue('');

  }

  newSearch() {
    this.loadSheets = true;
    this.nextPage = 1;
    this.exerciceList = [];
    this.getAvailableExercice();
  }

  excludeAssignedSheet() {
    this.exerciceList = this.exerciceList.filter(exercice => this.taskSheetToDo.map(task => task.what.id).indexOf(exercice.id) === -1)
  }

  emitViewEmitter(sheet: ExerciceSheet, mode) {
    this.emitSheetToView.emit({ sheet: sheet, mode: mode });
  }

  assignSheetToClass(exercice: Exercice) {
    const _params = {
      title: `Exercice ${this.typeExercice} à faire`,
      task_sender: 'teacher',
      sender_entity_id: this.currentUser.id,
      task_recipient: 'student',
      recipient_entity_id: this.formation.student.id,
      what_entity: 'exercice',
      what_entity_id: exercice.id,
      for_entity: 'formation',
      for_entity_id: this.formation.id
    };
    this.taskService.postTask(_params).subscribe(result => {
      this.taskSheetToDo.push(result);
      this.excludeAssignedSheet();
      this.isSheetAdded.emit(true);
    })
  }

  deleteTask(task) {
    this.taskService.patchTask(task.id, { status: 'deleted' }).subscribe(result => {
      this.taskSheetToDo = this.taskSheetToDo.filter(_task => _task.id !== task.id)
      this.exerciceList.push(task.what)
    })
  }

  clickRowSheet(sheet: ExerciceSheet) {
    if (this.site === 'lingueopro') {
      this.emitViewEmitter(sheet, 'mobile');
    }
  }
}
